import React, { Component } from "react";
import {
  Box,
  Button,
  Backdrop,
  Typography,
  CircularProgress,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import DialogTwoFa from "./components/DialogTwoFa";
import * as Yup from "yup";
import { Formik } from "formik";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import agent from "../../agent/agent";
import { showError } from "../../utils/notifications";
import { fetchGetUser } from "../../store/UserStore";
import Logo from "../../icons/Logo";

const initValues = {
  email: '',
  password: ''
}
class Authorization extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isBackdrop: false
    };
    this.refDialogTwoFa = React.createRef();
  }

  onAuth = async (body) => {
    await this.setState({ isBackdrop: true });

    const resAuth = await agent.post('/auth/login', body)
      .then((res) => res.data).catch((err) => {
        return { error: err.response?.data?.details || 'Ошибка сервера, повторите попытку позднее.' }
      });
    if (resAuth?.error) {
      await this.setState({ isBackdrop: false });
      showError('Ошибка авторизации', resAuth?.error);
      return
    }

    const sessionId = resAuth?.data?.session_id;
    const isTwoFa = Boolean(resAuth?.data?.['2fa_required'] || false);
    localStorage.setItem('sessionId', sessionId);
    if (!!isTwoFa) {
      await this.setState({ isBackdrop: false });
      this.refDialogTwoFa.current.open({
        onSubmit: this.onSubmit2fa.bind(this),
      })
      return
    }

    await this.props.fetchGetUser();
    await this.setState({ isBackdrop: false });
  }
  onSubmit2fa = async (values) => {
    await this.setState({ isBackdrop: true });
    const body = {
      ...values,
      session_id: localStorage.getItem('sessionId'),
    }
    const res = await agent.post('/auth/2fa', body)
      .then((res) => {
        if (res?.data?.data?.error) {
          return { error: res?.data?.data?.error_text }
        }
        return res.data
      }).catch((err) => {
        return { error: err.response?.data?.error_text || 'Ошибка сервера, повторите попытку позднее.' }
      });
    if (res?.error) {
      await this.setState({ isBackdrop: false });
      showError('Ошибка авторизации', res?.error);
      return
    }

    const sessionId = res?.data?.session_id;
    localStorage.setItem('sessionId', sessionId);
    await this.props.fetchGetUser();
    await this.setState({ isBackdrop: false });
  }

  render() {
    const { isBackdrop } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.page}>
        <div className={classes.card}>
          <div className={classes.logoWrap}>
            <Logo sx={{ fontSize: 40, width: 40, height: 29 }} />
            <div className={classes.logoText}>
              <span className={classes.logoTitle}>ЦИФРОВОЙ ПУТЬ</span>
            </div>
          </div>

          <Typography className={classes.heading}>Авторизация</Typography>

          <Formik
            initialValues={initValues}
            validationSchema={validationSchema}
            onSubmit={this.onAuth}
          >{(props) => {
            const { values, errors, touched, handleSubmit, handleChange } = props;
            return (
              <div className={classes.form}>
                <TextField
                  value={values.email}
                  label="Email"
                  name="email"
                  variant="outlined"
                  fullWidth
                  helperText={touched.email && errors.email}
                  error={Boolean(touched.email && errors.email)}
                  onChange={handleChange}
                />
                <TextField
                  value={values.password}
                  type="password"
                  label="Пароль"
                  name="password"
                  variant="outlined"
                  fullWidth
                  helperText={touched.password && errors.password}
                  error={Boolean(touched.password && errors.password)}
                  onChange={handleChange}
                />
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleSubmit}
                  className={classes.submitBtn}
                >
                  Войти
                </Button>
                <Box display="flex" justifyContent="center">
                  <Button
                    component={Link}
                    variant="text"
                    size="small"
                    to="/password-reset"
                    className={classes.linkBtn}
                  >
                    Забыли пароль?
                  </Button>
                </Box>
              </div>
            )
          }}</Formik>
        </div>

        <Backdrop open={isBackdrop}>
          <CircularProgress />
        </Backdrop>
        <DialogTwoFa ref={this.refDialogTwoFa} />
      </div>
    );
  }
}

const validationSchema = Yup.object().shape({
  email: Yup.string().email('Некорректно заполнен Email').required('Обязательно к заполнению'),
  password: Yup.string().required('Обязательно к заполнению'),
});

const useStyles = makeStyles(() => ({
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#F4F4F5",
  },
  card: {
    width: "100%",
    maxWidth: 420,
    background: "#fff",
    borderRadius: 8,
    border: "1px solid #E4E4E7",
    padding: "40px 36px",
  },
  logoWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    marginBottom: 32,
  },
  logoText: {
    display: "flex",
    flexDirection: "column",
  },
  logoTitle: {
    fontSize: 15,
    fontWeight: 700,
    lineHeight: "18px",
    color: "#27272A",
    letterSpacing: "0.02em",
  },
  heading: {
    fontSize: 20,
    fontWeight: 600,
    color: "#27272A",
    textAlign: "center",
    marginBottom: 24,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  submitBtn: {
    height: 44,
    fontSize: 15,
    fontWeight: 600,
    marginTop: 4,
  },
  linkBtn: {
    textTransform: "none",
    fontWeight: 400,
    fontSize: 14,
    color: "#71717A",
    "&:hover": {
      color: "#4F39F6",
      backgroundColor: "transparent",
    },
  },
}));

const StyledAuthorization = (props) => {
  const classes = useStyles();
  return <Authorization {...props} classes={classes} />;
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  fetchGetUser: () => dispatch(fetchGetUser())
});

export default connect(mapStateToProps, mapDispatchToProps)(StyledAuthorization)
